import { ReactNode, useMemo } from 'react';
import { CacheProvider } from '@emotion/react';
import createCache, { StylisPlugin } from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { useConfig } from '../providers/ConfigProvider';

export type Direction = 'ltr' | 'rtl';

// Create caches once outside component so they are never recreated
const cacheRtl = createCache({
  key: 'rtl',
  prepend: true,
  stylisPlugins: [rtlPlugin as StylisPlugin],
});

const cacheLtr = createCache({
  key: 'css',
  prepend: true,
});

interface RTLLayoutProps {
  children: ReactNode;
}

export const RTLLayout = ({ children }: RTLLayoutProps) => {
  const { direction } = useConfig();
  const cache = useMemo(() => (direction === 'rtl' ? cacheRtl : cacheLtr), [direction]);

  return (
    <CacheProvider value={cache}>
      {children}
    </CacheProvider>
  );
};
